import React from 'react';
import './APP.css'


interface PopupProps {
  text: string;
}

const Popup: React.FC<PopupProps> = ({ text }) => {
  return (
    <div className="popup">
      {text}
    </div>
  );
};

export default Popup;